import Type from "@/model/types/Type";

const type = {
    EXACT: 1,
    ESTIMATED: 2,
}

const list = [
    {
        value: type.EXACT,
        text: "Ano Exato",
    },
    {
        value: type.ESTIMATED,
        text: "Ano Estimado",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}